let loginCheck = {
    checkLoginStatus:function (code){
        if (code === 200){
            return true
        }else {
            return false
        }

    },
    checkRememberPassword:function (){
        if (localStorage.getItem("rememberUser")!==null&&JSON.parse(localStorage.getItem("rememberUser")).length!==0){
            return true
        }else {
            return false
        }

    },
    checkUserExist:function (e,x,y,z,m){
      let length = e.length
        for (let i=0;i<length;i++){
            if (e[i].userName===x){
                e.splice(i,1)
                let userInfo ={
                    "userName":x,
                    "passWord":y,
                    "nickName":z,
                    "photo":m
                }
                e.unshift(userInfo)
                localStorage.setItem("rememberUser",JSON.stringify(e))
                return true
            }
        }
        return false
    },
    removeUser:function (e,x){
        let length = e.length
        for (let i=0;i<length;i++){
            if (e[i].userName===x){
                e.splice(i,1)
                return true
            }
        }
        return false
    },
    checkSimilarCount:function (e,x){
        // console.log(e.length)
        // console.log(x.length)
        let size = e.length
        let length = x.length
        if (length === 0){
            return null
        }

        for (let i=0;i<size;i++){
            if (e[i].userName.substr(0,length)===x){
                return e[i].userName
            }
        }
        return null
    },

    getPassword:function (e,x){
        let size = e.length
        for (let i=0;i<size;i++){
            if (e[i].userName===x){
                return e[i].passWord
            }
        }
        return null
    },

    loginLoading:function (e){
        e = "加载中。"

        setTimeout(()=>{
            e = "加载中。"
        },500)
        setTimeout(()=>{
            e = "加载中。。"
        },1000)
        console.log(e)
        setTimeout(()=>{
            e = "加载中。。。"
        },1500)
        setTimeout(()=>{
            e = "加载中"
        },2000)
        console.log(e)
    }


}

export default loginCheck
